var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-quality-chart"},[_c('div',{staticClass:"text-center mb-4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"chart-container"},[_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.chartSeries,"height":"400"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }